import React from "react";

const ITEMS = [
  "100% AMERICAN STEEL",
  "HANDCRAFTED IN FLORIDA",
  "RECLAIMED MATERIALS",
  "ONE OF ONE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      className="relative bg-[#0A0A0A] border-y border-zinc-900 py-6 overflow-hidden"
      data-testid="marquee-strip"
    >
      <div className="flex w-max animate-marquee gap-12 whitespace-nowrap">
        {row.map((t, i) => (
          <span
            key={`${t}-${i}`}
            className="font-heading uppercase text-3xl md:text-4xl tracking-[0.18em] text-zinc-200 flex items-center gap-12"
          >
            {t}
            <span className="text-[#D9501E]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
